<template>
  <li>
    <router-link :to="{ name: 'graduates.single', params: { id: graduate.id } }">
      <p class="strong">{{ graduate.name }}</p>
      <ul class="details">
        <li>Program: {{ graduate.program.name }}</li>
        <li>Placement: {{ currentPlacement ? currentPlacement.number : null | nullable }}</li>
        <li>Agency: {{ currentPlacementAgency | nullable }}</li>
      </ul>
    </router-link>
  </li>
</template>

<script>
import { helpers } from 'mixins/graduates'
export default {
  mixins: [helpers],

  props: {
    graduate: {
      required: true,
      type: Object
    }
  }
}
</script>
